import React from 'react';
import { useTranslation } from 'react-i18next';
import { QueryResult } from '@apollo/client';
import { NewSection } from '../NewSection';
import { CardsLayout } from '../ui/CardsLayout';
import { ItemCard } from '../ui/ItemCard';
import { useBookmarks } from '../../hooks/useBookmarks';
import { ItemSectionSkeleton } from './ItemSectionSkeleton';
import { SearchVippedAllQuery } from '../../graphql/graphql';

interface VipResidenceSectionProps {
  searchVippedResidencesQuery: QueryResult<SearchVippedAllQuery>;
}

export const VipResidenceSection: React.FC<VipResidenceSectionProps> = ({
  searchVippedResidencesQuery
}) => {
  const { t } = useTranslation();
  const { isBookmarked } = useBookmarks();

  const itemsVipResidenceList =
    (searchVippedResidencesQuery.data?.vipResidenceItems &&
      searchVippedResidencesQuery.data?.vipResidenceItems.map(item => (
        <ItemCard key={item.id} {...item} inBookmarks={isBookmarked(item.id)} />
      ))) ||
    [];

  if (!itemsVipResidenceList.length && !searchVippedResidencesQuery.loading)
    return null;

  return (
    <NewSection
      id="search-page-vipped-residences"
      title={t('sections.vipped_residences.title')}
      headlineType="h3"
    >
      {itemsVipResidenceList.length ? (
        <CardsLayout>{itemsVipResidenceList}</CardsLayout>
      ) : (
        <ItemSectionSkeleton />
      )}
    </NewSection>
  );
};
